"use client";
import { usePrescriptionContext } from "@/src/provider";
import { FmPicker } from "@/ui-component";
import React, { useMemo, useState } from "react";
import RxTitle from "../RxTitle";
import stl from "../PD/pdHelp.module.scss";
import variable from "@/src/styles/variables.module.scss";
import { useTranslation } from "@/src/i18n/client";
interface IProps {
    selectData: Record<string, number[]>;
    onChange?: () => void;
}
const BirthYear: React.FC<IProps> = (props) => {
    const { t } = useTranslation(["lens", "rx"]);
    const [activeData, setPrescription] = usePrescriptionContext((state) => [
        state.activeData,
        state.setPrescription,
    ]);

    const [pickerOpen, setPickerOpen] = useState(false);

    const defaultOption: {
        label: string;
        value: string;
    } = useMemo(() => {
        return { value: "", label: t("lens:Rx.Select") };
    }, [t]);
    const birthYear = useMemo(() => {
        const temp = props.selectData["birth_year"].map(
            (item: string | number) => {
                return {
                    label: item,
                    value: item.toString(),
                };
            },
        );
        temp.unshift(defaultOption);
        return temp;
    }, [defaultOption, props.selectData]);

    return (
        <div className={stl["pd-container"]}>
            <RxTitle title={t("lens:Rx.BirthYear")} />
            <div className={stl["wrapper-container"]}>
                <FmPicker
                    borderColor={variable.main}
                    name={"birth_year"}
                    inputClassName={stl["picker-wrapper"]}
                    dataSource={birthYear}
                    open={pickerOpen}
                    confirm={"confirm"}
                    cancel={"cancel"}
                    onChange={(open, value) => {
                        setPickerOpen(open);
                        setPrescription({
                            birth_year: value as number,
                        });
                        props.onChange?.();
                    }}
                    defaultValue={defaultOption.value}
                    value={
                        activeData.prescription.birth_year ??
                        defaultOption.value
                    }
                    classes={{ icon: stl["icon"] }}
                ></FmPicker>
            </div>
            <p className={stl["sub-text"]}>{t("rx:birthSelectText")}</p>
        </div>
    );
};

export default BirthYear;
